// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__SMK7r"};